"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = require("./StringUtils");
function toSimpleCurrency(value, suffixSeparator) {
    if (suffixSeparator === void 0) { suffixSeparator = ""; }
    var newValue = Number(value);
    var suffixes = ["", "K", "M", "B", "T"];
    var ix = 0;
    while (ix < suffixes.length && newValue >= 1000) {
        newValue = newValue / 1000;
        ix++;
    }
    return newValue.toFixed(2) + suffixSeparator + suffixes[ix];
}
exports.toSimpleCurrency = toSimpleCurrency;
function toFormattedCurrency(value, fractions) {
    if (fractions === void 0) { fractions = 2; }
    if (value == undefined)
        value = 0;
    value = Number(value);
    if (fractions === 0) {
        var val = value.toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
        val = val.substring(0, val.indexOf("."));
        return val;
    }
    else
        return value.toFixed(fractions).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
}
exports.toFormattedCurrency = toFormattedCurrency;
function convertValueToCurrency(value) {
    value = StringUtils_1.toNumberString(value, 2);
    if (value == undefined)
        return undefined;
    value = value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    return value;
}
exports.convertValueToCurrency = convertValueToCurrency;
function convertCurrencyToValue(text) {
    return StringUtils_1.toNumberString(text, 2);
}
exports.convertCurrencyToValue = convertCurrencyToValue;
//# sourceMappingURL=Currency.js.map